import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffStampsTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      role_id: null,
      type: '',
      number: '',
      revision: '',
      observation: '',
      date: '',
      staff_stamps: [],
      stamp_types: [
        {value: "Círculo", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Circulo},
        {value: "Triângulo", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Triangulo},
        {value: "Quadrado", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Quadrado},
        {value: "Pentágono", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Pentagono},
        {value: "Hexágono", label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Hexagono},
      ],
      roles_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    // this.delete = this.delete.bind(this);
    this.export = this.export.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }
  
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_stamps)) {
      this.setState({
        staff_stamps: newProps.staff_stamps,
        roles_list: newProps.roles_list,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     role_id: this.state.role_id,
  //     type: this.state.type,
  //     number: this.state.number,
  //     revision: this.state.revision,
  //     observation: this.state.observation,
  //     date: this.state.date,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/carimbo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.setState({ staff_stamps: responseJson.data });
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  
  // // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse carimbo?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_stamps: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse carimbo?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       only_active: this.state.only_active,
  //       staff_id: this.state.staff_id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.setState({ staff_stamps: responseJson.data });
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/carimbos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_stamps: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/carimbos/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_stamps: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }
  export(event) {
    var self = this;
    self.props.handleAlert('', '', 'open');
    var staff_stamp_id = event;
    var url = '/exportar/carimbo/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + url + staff_stamp_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  // addToRevision(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de associar esse carimbo a uma revisão de designação aberta?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/revisao/carimbo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // delete($staff_stamp_id) {
  //   var confirm = window.confirm('Tem certeza que deseja deletar esse carimbo?');
  //   if (confirm) {
  //     var self = this;
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/' + $staff_stamp_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.refreshData(responseJson);
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tituloCarimbos}</h3>
  <hr/>
  {(this.state.staff_stamps === null || typeof this.state.staff_stamps === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.nenhumCarimboCadastrado}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.DataDeEmissao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Funcao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.TipoDeCarimbo}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Numero}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Revisao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Observacao}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Status}</th>
          {/* <th className="col-md-1 text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_stamps).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_stamps[k].date_str}</td>
              <td className="text-center">{self.state.staff_stamps[k].role}</td>
              <td className="text-center">{self.state.staff_stamps[k].type}</td>
              <td className="text-center">{self.state.staff_stamps[k].number}</td>
              <td className="text-center">{self.state.staff_stamps[k].number_str}</td>
              <td className="text-center">{self.state.staff_stamps[k].observation}</td>
              <td className="text-center">{(self.state.staff_stamps[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                <button className="btn btn-info btn-sm" onClick={() => {self.export(self.state.staff_stamps[k].id)}}><i className="fa fa-fw fa-file-pdf-o"></i></button>
                </td> 
              {/* 
                {(self.state.staff_stamps[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_stamps[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_stamps[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-primary" value={self.state.staff_stamps[k].id} onClick={self.addToRevision}><i className="fa fa-fw fa-plus"></i></button>
                <button className="btn btn-sm btn-danger" onClick={() => {self.delete(self.state.staff_stamps[k].id)}}><i className="fa fa-fw fa-trash"></i></button>
              */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Adicionar carimbo</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Tipo de carimbo:</label>
        <Select
          className="form-field-name"
          name="type"
          value={this.state.type}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'type')}
          options={this.state.stamp_types}
          required
        />    
      </div>
      <div className="col-md-6 form-group">
        <label>Função:</label>
        <Select
          className="form-field-name"
          name="role_id"
          value={this.state.role_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'role_id')}
          options={this.state.roles_list}
          required
        />    
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Número:</label>
        <input type="text" className="form-control" name="number" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
      </div>
      <div className="col-md-6 form-group">
        <label>Data de emissão:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" required />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Observações:</label>
        <input type="textarea" className="form-control" name="observation" value={this.state.observation} onChange={this.handleChange.bind(this, 'observation')} />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar carimbo</button>
  </form> */}
</div>
    );
  }
}

export default StaffStampsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffStampsTab.js